export { ReactComponent as AddIcon } from './AddIcon.svg';
export { ReactComponent as AddPlusIcon } from './AddPlusIcon.svg';
export { ReactComponent as AlertIcon } from './AlertIcon.svg';
export { ReactComponent as AnsweredWithoutMetricAnswerIcon } from './AnsweredWithoutMetricAnswerIcon.svg';
export { ReactComponent as DeprecatedAlertIcon } from './DeprecatedAlertIcon.svg';
export { ReactComponent as ArrowBackwardIcon } from './ArrowBackwardIcon.svg';
export { ReactComponent as ArrowCloseIcon } from './ArrowCloseIcon.svg';
export { ReactComponent as DeprecatedArrowCloseIcon } from './DeprecatedArrowCloseIcon.svg';
export { ReactComponent as ArrowDownIcon } from './ArrowDownIcon.svg';
export { ReactComponent as ArrowForwardIcon } from './ArrowForwardIcon.svg';
export { ReactComponent as ArrowFullscreenIcon } from './ArrowFullscreenIcon.svg';
export { ReactComponent as DeprecatedArrowFullscreenIcon } from './DeprecatedArrowFullscreenIcon.svg';
export { ReactComponent as ArrowLinkIcon } from './ArrowLinkIcon.svg';
export { ReactComponent as ArrowRightIcon } from './ArrowRightIcon.svg';
export { ReactComponent as ArrowUpAndDownIcon } from './ArrowUpAndDownIcon.svg';
export { ReactComponent as ArrowUpIcon } from './ArrowUpIcon.svg';
export { ReactComponent as ArrowWidthIcon } from './ArrowWidthIcon.svg';
export { ReactComponent as DeprecatedArrowWidthIcon } from './DeprecatedArrowWidthIcon.svg';
export { ReactComponent as CalendarIcon } from './CalendarIcon.svg';
export { ReactComponent as DeprecatedCalendarIcon } from './DeprecatedCalendarIcon.svg';
export { ReactComponent as CancelIcon } from './CancelIcon.svg';
export { ReactComponent as DeprecatedCancelIcon } from './DeprecatedCancelIcon.svg';
export { ReactComponent as ChartResultIcon } from './ChartResultIcon.svg';
export { ReactComponent as ChatIcon } from './Chat.svg';
export { ReactComponent as ChatInfoIcon } from './ChatInfo.svg';
export { ReactComponent as CheckBoxIcon } from './CheckBoxIcon.svg';
export { ReactComponent as DeprecatedCheckBoxIcon } from './DeprecatedCheckBoxIcon.svg';
export { ReactComponent as CheckIcon } from './CheckIcon.svg';
export { ReactComponent as DeprecatedCheckIcon } from './DeprecatedCheckIcon.svg';
export { ReactComponent as CheckLightIcon } from './CheckLightIcon.svg';
export { ReactComponent as ChevronDownFilledIcon } from './ChevronDownFilledIcon.svg';
export { ReactComponent as ChevronDownIcon } from './ChevronDownIcon.svg';
export { ReactComponent as DeprecatedChevronDownIcon } from './DeprecatedChevronDownIcon.svg';
export { ReactComponent as ChevronLeftFilledIcon } from './ChevronLeftFilledIcon.svg';
export { ReactComponent as ChevronLeftIcon } from './ChevronLeftIcon.svg';
export { ReactComponent as DeprecatedChevronLeftIcon } from './DeprecatedChevronLeftIcon.svg';
export { ReactComponent as ChevronRightFilledIcon } from './ChevronRightFilledIcon.svg';
export { ReactComponent as ChevronRightIcon } from './ChevronRightIcon.svg';
export { ReactComponent as ChevronUpFilledIcon } from './ChevronUpFilledIcon.svg';
export { ReactComponent as ChevronUpIcon } from './ChevronUpIcon.svg';
export { ReactComponent as DeprecatedChevronUpIcon } from './DeprecatedChevronUpIcon.svg';
export { ReactComponent as CloseFilledIcon } from './CloseFilledIcon.svg';
export { ReactComponent as DeprecatedCloseFilledIcon } from './DeprecatedCloseFilledIcon.svg';
export { ReactComponent as CloseIcon } from './CloseIcon.svg';
export { ReactComponent as DeprecatedCloseIcon } from './DeprecatedCloseIcon.svg';
export { ReactComponent as CommentWarningIcon } from './CommentWarningIcon.svg';
export { ReactComponent as DeprecatedCommentWarningIcon } from './DeprecatedCommentWarningIcon.svg';
export { ReactComponent as CompanyIcon } from './CompanyIcon.svg';
export { ReactComponent as ContentCopyIcon } from './ContentCopy.svg';
export { ReactComponent as CopyIcon } from './CopyIcon.svg';
export { ReactComponent as CopyLinkIcon } from './CopyLinkIcon.svg';
export { ReactComponent as DeleteIcon } from './DeleteIcon.svg';
export { ReactComponent as DotMenuHorizontalIcon } from './DotMenuHorizontalIcon.svg';
export { ReactComponent as DotMenuVerticalIcon } from './DotMenuVerticalIcon.svg';
export { ReactComponent as DownloadIcon } from './Download.svg';
export { ReactComponent as EditIcon } from './EditIcon.svg';
export { ReactComponent as DeprecatedEditIcon } from './DeprecatedEditIcon.svg';
export { ReactComponent as EmailIcon } from './EmailIcon.svg';
export { ReactComponent as DeprecatedEmailIcon } from './DeprecatedEmailIcon.svg';
export { ReactComponent as ErrorWarningIcon } from './ErrorWarningIcon.svg';
export { ReactComponent as DeprecatedErrorWarningIcon } from './DeprecatedErrorWarningIcon.svg';
export { ReactComponent as ExploreIcon } from './ExploreIcon.svg';
export { ReactComponent as FiltersIcon } from './FiltersIcon.svg';
export { ReactComponent as GrabHandleIcon } from './GrabHandleIcon.svg';
export { ReactComponent as HamburgerMenuIcon } from './HamburgerMenuIcon.svg';
export { ReactComponent as HeatmapIcon } from './HeatmapIcon.svg';
export { ReactComponent as HourGlassIcon } from './HourGlassIcon.svg';
export { ReactComponent as InfoIcon } from './InfoIcon.svg';
export { ReactComponent as DeprecatedInfoIcon } from './DeprecatedInfoIcon.svg';
export { ReactComponent as LanguageIcon } from './LanguageIcon.svg';
export { ReactComponent as LeaderboardIcon } from './LeaderboardIcon.svg';
export { ReactComponent as LineIcon } from './LineIcon.svg';
export { ReactComponent as LinkIcon } from './LinkIcon.svg';
export { ReactComponent as MailNotOpenedIcon } from './MailNotOpenedIcon.svg';
export { ReactComponent as MailOpenedIcon } from './MailOpenedIcon.svg';
export { ReactComponent as MinusIcon } from './MinusIcon.svg';
export { ReactComponent as MouseAreaIcon } from './MouseAreaIcon.svg';
export { ReactComponent as MouseIcon } from './MouseIcon.svg';
export { ReactComponent as MouseLeftIcon } from './MouseLeftIcon.svg';
export { ReactComponent as DeprecatedMouseLeftIcon } from './DeprecatedMouseLeftIcon.svg';
export { ReactComponent as MouseRightIcon } from './MouseRightIcon.svg';
export { ReactComponent as DeprecatedMouseRightIcon } from './DeprecatedMouseRightIcon.svg';
export { ReactComponent as NoIcon } from './NoIcon.svg';
export { ReactComponent as DeprecatedNoIcon } from './DeprecatedNoIcon.svg';
export { ReactComponent as NoMetricsQuestionIcon } from './NoMetricsQuestion.svg';
export { ReactComponent as NoSurveyIcon } from './NoSurvey.svg';
export { ReactComponent as NotDeliveredIcon } from './NotDelivered.svg';
export { ReactComponent as OverviewIcon } from './OverviewIcon.svg';
export { ReactComponent as PanelCollapseIcon } from './PanelCollapseIcon.svg';
export { ReactComponent as PanelExpandIcon } from './PanelExpandIcon.svg';
export { ReactComponent as PersonAddIcon } from './PersonAddIcon.svg';
export { ReactComponent as PersonMultiSelectIcon } from './PersonMultiSelectIcon.svg';
export { ReactComponent as DeprecatedPersonMultiSelectIcon } from './DeprecatedPersonMultiSelectIcon.svg';
export { ReactComponent as PersonRemoveIcon } from './PersonRemoveIcon.svg';
export { ReactComponent as PhoneIcon } from './PhoneIcon.svg';
export { ReactComponent as DeprecatedPhoneIcon } from './DeprecatedPhoneIcon.svg';
export { ReactComponent as QuestionMarkIcon } from './QuestionMarkIcon.svg';
export { ReactComponent as RadioButtonIcon } from './RadioButtonIcon.svg';
export { ReactComponent as DeprecatedRadioButtonIcon } from './DeprecatedRadioButtonIcon.svg';
export { ReactComponent as Refresh } from './Refresh.svg';
export { ReactComponent as RenameIcon } from './RenameIcon.svg';
export { ReactComponent as RepeatIcon } from './Repeat.svg';
export { default as RoundCheckedIcon } from './RoundCheckedIcon'; // Normal component
export { ReactComponent as RouteSplitIcon } from './RouteSplitIcon.svg';
export { ReactComponent as SaveIcon } from './SaveIcon.svg';
export { ReactComponent as DeprecatedSaveIcon } from './DeprecatedSaveIcon.svg';
export { ReactComponent as ScrollIcon } from './ScrollIcon.svg';
export { ReactComponent as DeprecatedScrollIcon } from './DeprecatedScrollIcon.svg';
export { ReactComponent as SearchIcon } from './SearchIcon.svg';
export { ReactComponent as SendIcon } from './SendIcon.svg';
export { default as DeprecatedSendIcon } from './DeprecatedSendIcon'; // Normal component
export { ReactComponent as SettingsIcon } from './SettingsIcon.svg';
export { ReactComponent as ShareIcon } from './ShareIcon.svg';
export { ReactComponent as DeprecatedShareIcon } from './DeprecatedShareIcon.svg';
export { ReactComponent as SurveyIcon } from './SurveyIcon.svg';
export { ReactComponent as TeamIcon } from './TeamIcon.svg';
export { ReactComponent as TellFilledIcon } from './TellFilledIcon.svg';
export { ReactComponent as DeprecatedTellFilledIcon } from './DeprecatedTellFilledIcon.svg';
export { ReactComponent as TextfieldIcon } from './TextfieldIcon.svg';
export { ReactComponent as DeprecatedTextfieldIcon } from './DeprecatedTextfieldIcon.svg';
export { ReactComponent as TextfieldMandatoryIcon } from './TextfieldMandatoryIcon.svg';
export { ReactComponent as DeprecatedTextfieldMandatoryIcon } from './DeprecatedTextfieldMandatoryIcon.svg';
export { ReactComponent as TrendsIcon } from './TrendsIcon.svg';
export { ReactComponent as UniIcon } from './uniIcon.svg';
export { ReactComponent as VectorIcon } from './VectorIcon.svg';
export { ReactComponent as VisibilityOffIcon } from './VisibilityOffIcon.svg';
export { ReactComponent as DeprecatedVisibilityOffIcon } from './DeprecatedVisibilityOffIcon.svg';
export { ReactComponent as VisibilityOnIcon } from './VisibilityOnIcon.svg';
export { ReactComponent as DeprecatedVisibilityOnIcon } from './DeprecatedVisibilityOnIcon.svg';
export { ReactComponent as NotSend } from './NotSend.svg';
export { ReactComponent as GdprIcon } from './GdprIcon.svg';
export { ReactComponent as ChoiceIcon } from './ChoiceIcon.svg';
export { ReactComponent as OpenIcon } from './OpenIcon.svg';
export { ReactComponent as PercentageIcon } from './PercentageIcon.svg';
